import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import { Concept } from '../../../../../types/Survey/Analysis/Concept'
import Headline from '../../../../UI/Headline/Headline'
import Number from '../../../../UI/Input/Number'
import useConceptConfiguration from '../ConceptCalculation/useConceptConfiguration'
import _ from 'lodash'
import { getUUID } from '../../../../../utility'
import SingleUebergeordneterBedarf from './SingleUebergeordneterBedarf'
import { PlusIcon } from '@heroicons/react/24/solid'

const Optimization: React.FC<{}> = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const { getActiveConcept, updateActiveConcept } = useConceptConfiguration()

  const updateConceptProp = (key: any) => (value: any) => {
    const updatedConcept: Concept = { ...getActiveConcept() }
    _.set(updatedConcept, key, value)
    updateActiveConcept(updatedConcept)
  }

  const updateUebergeordneteBedarfe = (uuid: string) => (key: string) => (value: number) => {
    const conceptCopy: Concept = { ...getActiveConcept() }
    if (Array.isArray(conceptCopy.optimization?.UEBERGEORDNETE_BEDARFE)) {
      conceptCopy.optimization.UEBERGEORDNETE_BEDARFE = conceptCopy.optimization.UEBERGEORDNETE_BEDARFE.map((b) => {
        if (b.uuid === uuid) {
          b[key] = value
        }
        return b
      })
    }
    updateActiveConcept(conceptCopy)
  }

  const addUebergeordneterBedarf = () => {
    const conceptCopy: Concept = { ...getActiveConcept() }
    conceptCopy.optimization.UEBERGEORDNETE_BEDARFE.push({
      uuid: getUUID(),
      name: '',
      practicalQM: 0,
      isNormSelected: false,
    })
    updateActiveConcept(conceptCopy)
  }

  const removeUebergeordneterBedarf = (uuid: string) => () => {
    const conceptCopy: Concept = { ...getActiveConcept() }
    if (Array.isArray(conceptCopy.floorMapping)) {
      conceptCopy.floorMapping = conceptCopy.floorMapping.filter((mapping) => mapping.targetUUID !== uuid)
    }
    conceptCopy.optimization.UEBERGEORDNETE_BEDARFE = conceptCopy.optimization.UEBERGEORDNETE_BEDARFE.filter((ub) => ub.uuid !== uuid)
    updateActiveConcept(conceptCopy)
  }

  if (!getActiveConcept()) return null
  const activeConcept = getActiveConcept()

  return (
    <div className="shadow-lg p-5">
      <Headline text={t.survey.analysis.concept.optimization.headline} />
      <div className="flex flex-col gap-5">
        <div>
          <div className="font-bold">{t.survey.analysis.concept.optimization.verkehrsflaechenPercentage}</div>
          <Number
            suffix={t.generic.percentageSuffix}
            value={activeConcept.optimization.verkehrsflaechenPercentage}
            onChange={updateConceptProp('optimization.verkehrsflaechenPercentage')}
            className="!w-1/3"
          />
        </div>
        <div>
          <div className="font-bold">{t.survey.analysis.concept.optimization.uebergeordneteBedarfe.title}</div>
          <div className="flex flex-col gap-2">
            {activeConcept.units.sum.UEBERGEORDNETE_BEDARFE.map((ub) => (
              <SingleUebergeordneterBedarf
                key={ub.uuid}
                data={ub}
                onChange={updateUebergeordneteBedarfe(ub.uuid)}
                remove={removeUebergeordneterBedarf(ub.uuid)}
              />
            ))}
            <div className="flex gap-3 justify-end mt-3">
              <div
                onClick={addUebergeordneterBedarf}
                className="w-6 aspect-square bg-cyan rounded-full flex items-center justify-center text-white cursor-pointer"
              >
                <PlusIcon className="fill-white w-5" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Optimization
